<template>
    <div>
    <div style="height: 100vh; width: 100%">
        <l-map ref="myMap" :zoom="zoom" :center="center" :options="mapOptions">
        <l-control-scale position="bottomleft" :maxWidth=150 :imperial="false"></l-control-scale>
        <l-aircraft v-if="aircraft_define"
        :addr="aircraft.addr"
        :type="aircraft.type"
        :lat-lng="aircraft.position"
        :lat-lngs="aircraft.polyline"
        :alive="false"
        :rotate="0"
        :select="false"
        :vpath="true"
        :wpath=2.5
        />
        <l-control :position="'topcenter'">
            <button class="btn btn-action" v-on:click="$router.go(-1)">
                <i class="icon icon-back"></i>
            </button>
        </l-control>
        <l-control-layers :position="'topleft'" />
        <l-tile-layer
            v-for="layer in layers"
            :key="layer.name"
            :url="layer.url"
            :name="layer.name"
            :options="layer.options"
            :attribution="layer.attribution"
            :visible="layer.visible"
            layer-type="base"
        />
        <l-control class="custom-control">
            <div class=select v-if="aircraft_define">
                <div class="center">
                    <div><b>{{flight.device.registration}}</b></div>
                    <div><b>{{flight.device.aircraft}}</b></div>
                    <div class="tooltip tooltip-bottom" :data-tooltip="tooltip"> <img class="c-hand tzi" :src="require('@/assets/tz.png')"></div>
                </div>
                <table>
                    <tr><td><b><u>Start</u></b>:</td><td><div>{{flight.start}}</div></td></tr>
                    <tr><td><b><u>Stop</u>:</b></td><td><div>{{flight.stop}}</div></td></tr>
                    <tr><td><b><u>Duration</u></b>:</td><td><div>{{flight.duration_hm}}</div></td></tr>
                </table>
            </div>
        </l-control>
        </l-map>
    </div>
    </div>
</template>

<script>
import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import { LMap, LControl, LControlLayers, LTileLayer, LControlScale} from 'vue2-leaflet';
import LAircraft from '@/components/aircraft.vue';
import { latLng } from "leaflet";
import axios from 'axios';

const api_url = process.env.VUE_APP_LIVEURL
let error_time=2000

export default {
    name: 'Trace',
    components: {
                LMap,
                LAircraft,
                LControl,
                LControlLayers,
                LTileLayer,
                LControlScale
    },
    data () {
        return {
            mapOptions: {
                zoomSnap: 0.5,
                zoomControl: false
            },
            zoom: 12,
            center: latLng(47.79861666666667, 3.7813333333333334),
            aircraft: {},
            flight: {},
            tz_name: '',
            tz_offset: '',
            aircraft_define: false,
            layers: [
                {
                    name: 'Esri',
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    options: {maxNativeZoom: 15},
                    attribution: '<a href="http://www.esri.com/" target="_blank">Esri</a>',
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'Stamen',
                    url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
                    options: {maxNativeZoom: 12},
                    attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; \
                    <a href="https://stamen.com/" target="_blank">Stamen Design</a> &copy; \
                    <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; \
                    <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
                    visible: false
                },
                {
                    name: 'OpenTopoMap',
                    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                    attribution: '<a href="http://opentopomap.org" target="_blank">OpenTopoMap</a>',
                    options: {maxNativeZoom: 15},
                    subdomains: 'a,b,c',
                    visible: false
                },
                {
                    name: 'OpenStreetMap',
                    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
                    visible: true
                }
            ],
        }
    },
    computed: {
        tooltip(){return `${this.tz_name}\n${this.tz_offset}`},
    },
    mounted (){
        this.flight = this.$store.getters.flight
        this.tz_name = this.$store.getters.tz[0]
        this.tz_offset = this.$store.getters.tz[1]
        // protect app for accessing directly (or refresh) on trace page
        if (this.flight.device === undefined) return
        
        let address = this.flight.device.address
        // take 30s before and after start detection for path display (in case of exact time) or +/- delta min (in case of approx time)
        let start = this.flight.start_tsp - (this.flight.start_delta!==undefined ? this.flight.start_delta*60 : 30)
        let stop = this.flight.stop_tsp + (this.flight.stop_delta!==undefined ? this.flight.stop_delta*60 : 30)
        let prom = axios.get([api_url, 'path', address, start, stop].join('/'), {timeout: error_time})
        prom.then (response => {
            let data = response.data
            if (data !== null && data.poly) {
                let len = data.poly.length
                this.aircraft['addr'] = this.flight.device.address
                this.aircraft['type'] = this.flight.device.aircraft_type
                this.aircraft['polyline'] = data.poly
                this.aircraft['alive'] = true
                this.aircraft['vpath'] = true
                let last_pos=data.poly[len-1]
                this.aircraft['position']=latLng(last_pos[0], last_pos[1])
                this.$refs.myMap.mapObject.fitBounds(data.poly)
                // protect aircraft & l-control components for access undefined reactive properties
                this.aircraft_define = true
            }
        })
        .catch(error => {console.log("Error while consuming live path Api:" + error)})
    }
}
</script>

<style>
div.leaflet-top, div.leaflet-bottom {
    position: absolute;
    z-index: 400;
    pointer-events: none;
}
.leaflet-control-scale {
    background-color: white;
}
.leaflet-control-layers label {
    display: block;
    text-align: left;
}
.circle {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;
}
.center {
  text-align: center;
}
.custom-control {
  background: #fff;
  border: 2px solid rgba(0,0,0,.2);
  border-radius: 0.5em;
  width: 150px;
  text-align: left;
}
.select {
    padding: 0.5em 0.5em;
}
.select table{
    border-spacing: 5px 0px;
}
.select table div {
    font-weight: bold;
    background-color: #eef0f3;
    border-radius: 0.5em;
    padding-top: 2px;
    padding-bottom: 2px;
}
.tzi {
    max-width: 20%;
    height: auto;
}
</style>